(() => {
  const publish = (name, detail = {}) => {
    if (window.SweatDecksAnalyticsEnabled !== true || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) return;
    const safeDetail = { intent: String(detail.intent || 'unknown').slice(0, 48), version: 'sd100x-v1' };
    document.dispatchEvent(new CustomEvent(`sweatdecks:${name}`, { detail: safeDetail }));
    try {
      window.Shopify?.analytics?.publish(name, safeDetail);
    } catch (_) {
      // The native form must never depend on analytics availability.
    }
  };

  document.querySelectorAll('[data-sdx-contact]').forEach((form) => {
    const intent = form.dataset.sdxIntent || 'general_support';
    let started = false;
    form.addEventListener('focusin', () => {
      if (started) return;
      started = true;
      publish('quote_started', { intent });
    });
    form.addEventListener('submit', (event) => {
      const trap = form.querySelector('[data-sdx-honeypot]');
      if (trap?.value) {
        event.preventDefault();
        const status = form.querySelector('[data-sdx-client-error]');
        if (status) {
          status.hidden = false;
          status.focus();
        }
        publish('quote_error', { intent });
        return;
      }
      const button = form.querySelector('[type="submit"]');
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.textContent = 'Sending…';
      }
      publish('quote_submitted', { intent });
    });
  });
})();
